import BaseService from "@/services/BaseService";
import * as URI from "../masters/constant";

const action = {
  async fetchMasterDropDownAction({ commit }, payload) {
    let url = URI.MASTER_EMAIL_DROP_DWON_URL;
    const response = await BaseService.getSchemePlanningClient().get(url);
    commit("setMasterEmailDropDown", response.data.data);
    return response.data.data;
  },
  async fetchMasterEmailGroupAction({ commit }, payload) {
    let path = "";
    if (payload.division) {
      path = `pageSize=${payload.page.pageSize}&pageNo=${payload.page.currentPage}&division=${payload.division}`;
    } else {
      path = `pageSize=${payload.page.pageSize}&pageNo=${payload.page.currentPage}`;
    }
    let url = URI.MASTER_EMAIL_GROUP_LIST_URL.replace(
      "{payload}",
      path
    ).replace("{groupTypeId}", payload.groupTypeId);
    const response = await BaseService.getSchemePlanningClient().get(url);
    commit("setMasterEmailGroups", response.data.data);
    return response.data.data;
  },
  async fetchGroupsBasedAction({ commit }, payload) {
    let url = URI.GROUP_BASED_LIST_URL.replace(
      "{groupTypeId}",
      payload.groupTypeId
    )
      .replace("{pageSize}", payload.page.pageSize)
      .replace("{currentPage}", payload.page.currentPage);
    const response = await BaseService.getSchemePlanningClient().get(url);
    commit("setGroupsBased", response.data.data);
    return response.data.data;
  },
  async fetchGroupBasedEmail({ commit }, payload) {
    let url = URI.GROUP_BASED_EMAIL_URL.replace("{payload}", payload);
    const response = await BaseService.getSchemePlanningClient().post(url);
    return response.data.data;
  },
  async fetchMasterEmailGroupTable3Action({ commit }, payload) {
    let path = `pageSize=${payload.page.pageSize}&pageNo=${payload.page.currentPage}`;
    let url = URI.MASTER_EMAIL_TABLE_3_FETCH.replace("{payload}", path).replace(
      "{groupNumber}",
      payload.groupNumber
    );
    const response = await BaseService.getSchemePlanningClient().get(url);
    return response.data.data;
  },
  async downloadExcelEmailMasterTable3Data({ commit }, payload) {
    let url = URI.EMAIL_MASTER_EXPORT_TABLE_3_DATA_FILE.replace(
      "{payload}",
      payload.groupNo
    );
    const response = await BaseService.getSchemePlanningClient().get(url, {
      responseType: "blob",
    });
    return response;
  },
  async downloadExcel({ commit }, payload) {
    let url = URI.EMAIL_MASTER_EXPORT_FILE.replace(
      "{groupTypeId}",
      payload.groupTypeId
    )
      .replace("{division}", payload.division)
      .replace("{withData}", payload.flag);
    const response = await BaseService.getSchemePlanningClient().get(url, {
      responseType: "blob",
    });
    return response;
  },
  async importEmailGroupCSV({ commit }, payload) {
    let url = URI.IMPORT_EMAIL_GROUP_CSV.replace(
      "{emailGroupId}",
      payload.emailGroupId
    )
      .replace("{division}", payload.division)
      .replace("{importValue}", payload.isInsert);
    const response = await BaseService.getSchemePlanningClient().post(
      url,
      payload.file,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    return response.data;
  },
  async createMasterGroupData({ commit }, payload) {
    let url = URI.CREATE_MASTER_GROUP.replace(
      "{groupTypId}",
      payload.groupTypId
    );
    const response = await BaseService.getSchemePlanningClient().post(
      url,
      payload.singleMasterEmailInfo
    );
    return response.data;
  },
  async deleteMasterGroupData({ commit }, payload) {
    let url = URI.DELETE_MASTER_GROUP;
    const response = await BaseService.getSchemePlanningClient().delete(url, {
      data: payload,
    });
    return response.data;
  },
  async createGroupEmailData({ commit }, payload) {
    let url = URI.CREATE_GROUP_EMAIL.replace("{groupName}", payload.groupName)
      .replace("{groupType}", payload.groupType)
      .replace("{divisionId}", payload.divisionId);
    const response = await BaseService.getSchemePlanningClient().post(url);
    return response.data;
  },
  async deleteGroupEmailData({ commit }, payload) {
    let url = URI.DELETE_GROUP_EMAIL.replace("{payload}", payload);
    const response = await BaseService.getSchemePlanningClient().delete(url, {
      data: payload,
    });
    return response.data;
  },
  async deleteAllGroupEmailData({ commit }, payload) {
    let ids = payload.ids.map((obj) => `ids=${obj}`).join("&");
    let url = URI.DELETE_ALL_GROUP_EMAIL.replace("{payload}", ids).replace(
      "{groupType}",
      payload.groupType
    );
    const response = await BaseService.getSchemePlanningClient().delete(url);
    return response.data;
  },
  async saveMasterEmailGroupAssociate({ commit }, payload) {
    let url = URI.SAVE_MASTER_EMAIL_GROUP_ASSOCIATE.replace(
      "{groupNo}",
      payload.groupNo
    );
    const response = await BaseService.getSchemePlanningClient().post(
      url,
      payload.emailAssociateDTO
    );
    return response.data;
  },

  /** Journals Master */
  // Headers
  async manualJournalCreateAction({ commit }, payload) {
    let url = URI.MANUAL_JOURNAL_CREATE;
    const response = await BaseService.getSchemePlanningClient().post(
      url,
      payload
    );
    return response.data;
  },
  async manualJournalTypeAction({ commit }, payload) {
    const url = URI.MANUAL_JOURNAL_TYPE;
    const res = await BaseService.getSchemePlanningClient().get(url);
    commit("setManualJournaltype", res.data.data);
  },
  async manualJournalHeaderListAction({ commit }, payload) {
    let url = URI.MANUAL_JOURNAL_HEADER_LIST.replace(
      "{currentPage}",
      payload.page.currentPage
    )
      .replace("{pageSize}", payload.page.pageSize)
      .replace("{value}", payload.sord.value)
      .replace("{sortOrder}", payload.sord.__sortOrder);
    const res = await BaseService.getSchemePlanningClient().get(url);
    commit("setManualJournalHeaderList", res.data.data);
    return res.data;
  },
  async manualJournalHeaderDeleteAction({ commit }, payload) {
    let url = URI.MANUAL_JOURNAL_HEADER_DELETE;
    const response = await BaseService.getSchemePlanningClient().delete(url, {
      data: payload,
    });
    return response.data;
  },
  async manualJournalHeaderExportAction({ commit }, payload) {
    let url = URI.MANUAL_JOURNAL_HEADER_EXPORT;
    const response = await BaseService.getSchemePlanningClient().get(url, {
      responseType: "blob",
    });
    return response;
  },

  // Lines
  async manualJournalLineExportAction({ commit }, payload) {
    let url = URI.MANUAL_JOURNAL_LINE_EXPORT.replace(
      "{journalId}",
      payload.id
    ).replace("{configMstId}", payload.configMstId);
    const response = await BaseService.getSchemePlanningClient().get(url, {
      responseType: "blob",
    });
    return response;
  },
  async manualJournalLineListAction({ commit }, payload) {
    const url = URI.MANUAL_JOURNAL_LINE_LIST.replace(
      "{journalId}",
      payload.id
    ).replace("{configMstId}", payload.configMstId);
    const res = await BaseService.getSchemePlanningClient().get(url);
    commit("setManualJournalLine", res.data.data);
    return res.data;
  },
  async manualPlanSchemeListAction({ commit }, payload) {
    const url = URI.MANUAL_JOURNAL_PLAN_SCHEME_LIST.replace(
      "{journalId}",
      payload.id
    ).replace("{configMstId}", payload.configMstId);
    const res = await BaseService.getSchemePlanningClient().get(url);
    commit("setJournalPlanSchemeLine", res.data.data);
    return res.data;
  },
  async manualJournalLineDeleteAction({ commit }, payload) {
    let url = URI.MANUAL_JOURNAL_LINE_DELETE;
    const response = await BaseService.getSchemePlanningClient().delete(url, {
      data: payload,
    });
    return response.data;
  },
  async manualJournalLineImportCSVAction({ commit }, payload) {
    let url = URI.MANUAL_JOURNAL_LINE_IMPORT.replace(
      "{journalId}",
      payload.linePayload.id
    ).replace("{configMstId}", payload.linePayload.configMstId);
    const response = await BaseService.getSchemePlanningClient().post(
      url,
      payload.data,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    return response.data;
  },
  async manualJournalLineUpdateAction({ commit }, payload) {
    let url = URI.MANUAL_JOURNAL_LINE_UPDATE;
    const response = await BaseService.getSchemePlanningClient().post(
      url,
      payload
    );
    return response.data;
  },
  //SIS-HIERARCHY
  async getHierarchyHeaderAction({ commit }) {
    let url = URI.HIERARCHY_HEADER_LIST_URL;
    const hierarchysHeaders = await BaseService.getSchemePlanningClient().get(
      url
    );
    return hierarchysHeaders.data;
  },
  async getHierarchyLineItemAction({ commit }, payload) {
    let url = URI.HIERARCHY_LINE_ITEM_LIST_URL.replace("salesId", payload);
    const hierarchysLineItem = await BaseService.getSchemePlanningClient().get(
      url
    );
    return hierarchysLineItem.data;
  },
  setHierarchyMasterHeaderItem({ commit }, payload) {
    commit("setHierarchyMasterHeaderItem", payload);
  },
  async hierarchyPurposeListAction({ commit }, payload) {
    let url = URI.HIERARCHY_PURPOSE_LIST_URL.replace(
      "{divisionCode}",
      payload.divisionCode
    ).replace("{channelCode}", payload.channelCode);
    const response = await BaseService.getSchemePlanningClient().get(url);
    return response.data;
  },
  async saveHierarchyHeaderData({ commit }, payload) {
    const response = await BaseService.getSchemePlanningClient().post(
      URI.HIERARCHY_SAVE_HEADER_URL,
      payload
    );
    return response.data;
  },
  async deleteLineItemRow({ commit }, payload) {
    const response = await BaseService.getSchemePlanningClient().delete(
      URI.HIERARCHY_DELETE_LINE_ITEM_URL,
      {
        data: payload,
      }
    );
    return response.data;
  },
  async saveHierarchyLineItemData({ commit }, payload) {
    const response = await BaseService.getSchemePlanningClient().post(
      URI.HIERARCHY_SAVE_LINE_ITEM_URL,
      payload
    );
    return response.data;
  },
  async hierarchyLineJobIdListAction({ commit }, payload) {
    let url = URI.HIERARCHY_LINE_JOB_ID_LIST_URL.replace(
      "{division}",
      payload.division
    )
      .replace("{channel}", payload.channel)
      .replace("{purpose}", payload.purpose);
    const response = await BaseService.getSchemePlanningClient().get(url);
    return response.data;
  },
  async hierarchyLinePartnerIdListAction({ commit }, payload) {
    let url = "";
    let pay = `32?division=${payload.division}&channelIds=${payload.channelIds}`;
    url = URI.HIERARCHY_LINE_PARTNER_ID_LIST_URL.replace("{payload}", pay);
    const response = await BaseService.getSchemePlanningClient().get(url);
    return response.data;
  },
  setHierarchyHeaderItem({ commit }, payload) {
    commit("setHierarchyHeaderItem", payload);
  },
  setHierarchyMasterLineItem({ commit }, payload) {
    commit("setHierarchyMasterLineItem", payload);
  },
  async getManualGridData({ commit }, payload) {
    let url = URI.HIERARCHY_MANUAL_ITEM_GRID_URL.replace("id", payload);
    const hierarchysManualGridItem =
      await BaseService.getSchemePlanningClient().get(url);
    return hierarchysManualGridItem.data;
  },

  /** Target Planning */
  // Headers
  async getMasterTargetGeoElementSales({ commit }, payload) {
    const url = URI.TARGET_PLANNING_MASTER_GEO_ELEMENT_SALES;
    const response = await BaseService.getSchemePlanningClient().put(
      url,
      payload
    );
    return response.data.data;
  },
  async targetPlanningCreateAction({ commit }, payload) {
    let url = URI.TARGET_PLANNING_CREATE;
    const response = await BaseService.getSchemePlanningClient().post(
      url,
      payload
    );
    return response.data;
  },
  async targetPlanningHeaderListAction({ commit }, payload) {
    let url = URI.TARGET_PLANNING_HEADER_LIST.replace(
      "{currentPage}",
      payload.page.currentPage
    )
      .replace("{pageSize}", payload.page.pageSize)
      .replace("{value}", payload.sord.value)
      .replace("{sortOrder}", payload.sord.__sortOrder);
    const res = await BaseService.getSchemePlanningClient().get(url);
    commit("setTargetPlanningHeaderList", res.data.data);
    return res.data;
  },
  async targetPlanningHeaderDeleteAction({ commit }, payload) {
    let url = URI.TARGET_PLANNING_HEADER_DELETE.replace("{id}", payload.id);
    const response = await BaseService.getSchemePlanningClient().delete(url, {
      data: payload,
    });
    return response.data;
  },
  async downloadExcelLinkedPlanSchemeAction({ commit }, payload) {
    let url = URI.MANUAL_JOURNAL_LINKED_PLAN_SCHEME.replace(
      "{configMstId}",
      payload.configMstId
    ).replace("{journalId}", payload.journalId);
    const response = await BaseService.getSchemePlanningClient().get(url, {
      responseType: "blob",
    });
    return response;
  },

  // Lines
  async targetPlanningLineItemExportAction({ commit }, payload) {
    let url = URI.TARGET_PLANNING_LINE_EXPORT.replace(
      "{targetPlanHeaderId}",
      payload.id
    );
    const response = await BaseService.getSchemePlanningClient().get(url, {
      responseType: "blob",
    });
    return response;
  },
  async targetPlanningLineItemListAction({ commit }, payload) {
    const url = URI.TARGET_PLANNING_LINE_LIST.replace(
      "{targetPlanHeaderId}",
      payload.id
    );
    const res = await BaseService.getSchemePlanningClient().get(url);
    commit("setTargetPlanningLine", res.data.data);
    return res.data;
  },
  async targetPlanningLineItemDeleteAction({ commit }, payload) {
    let url = URI.TARGET_PLANNING_LINE_DELETE.replace(
      "{targetPlanHeaderId}",
      payload.targetPlanHeaderId
    )
      .replace("{geoLevel}", payload.geoLevel)
      .replace("{geoSubLevel}", payload.geoSubLevel);
    const response = await BaseService.getSchemePlanningClient().delete(url, {
      data: payload,
    });
    return response.data;
  },
  async targetPlanningLineItemImportCSVAction({ commit }, payload) {
    let url = URI.TARGET_PLANNING_LINE_IMPORT.replace(
      "{targetPlanHeaderId}",
      payload.targetPlanHeaderId
    );
    const response = await BaseService.getSchemePlanningClient().post(
      url,
      payload.data,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    return response.data;
  },
  async freezeManualJournalHeaderAction({ commit }, payload) {
    const url = URI.MANUAL_JOURNAL_HEADER_FREEZE.replace(
      "{journalId}",
      payload
    );
    const response = await BaseService.getSchemePlanningClient().put(url);
    return response.data.data;
  },
  async gmcsExecptionToGtSchemeAction({ commit }, payload) {
    let url = URI.GMCS_EXECPTION_TO_GT.replace(
      "{applyonId}",
      payload.applyonId
    ).replace("{mstJnlHdrId}", payload.mstJnlHdrId);
    const response = await BaseService.getSchemePlanningClient().post(
      url,
      payload
    );
    return response.data;
  },
  async importSalesVDDAStatus({ commit }, payload) {
    let url = URI.IMPORT_SALES_VDDA_STATUS;
    const response = await BaseService.getSchemePlanningClient().get(url);
    return response.data.data;
  },

  /** Target Deployment */
  // Headers
  async getMasterTargetDeploymentAction({ commit }, payload) {
    const url = URI.TARGET_DEPLOYMENT_MASTER_URL;
    const response = await BaseService.getSchemePlanningClient().get(url);
    commit("setTargetDeploymentMaster", response.data);
    return response.data;
  },
  async targetDeploymentCreateAction({ commit }, payload) {
    let url = URI.TARGET_DEPLOYMENT_CREATE;
    const response = await BaseService.getSchemePlanningClient().post(
      url,
      payload
    );
    return response.data;
  },

  async targetDeploymentHeaderListAction({ commit }, payload) {
    let url = URI.TARGET_DEPLOYMENT_HEADER_LIST.replace(
      "{currentPage}",
      payload.page.currentPage
    )
      .replace("{pageSize}", payload.page.pageSize)
      .replace("{value}", payload.sord.value)
      .replace("{sortOrder}", payload.sord.__sortOrder);
    const res = await BaseService.getSchemePlanningClient().get(url);
    commit("setTargetDeploymentHeaderList", res.data);
    return res.data;
  },
  async targetDeploymentHeaderExportAction({ commit }, payload) {
    let url = URI.TARGET_DEPLOYMENT_HEADER_EXPORT;
    const response = await BaseService.getSchemePlanningClient().get(url, {
      responseType: "blob",
    });
    return response;
  },
  async targetDeploymentHeaderDeleteAction({ commit }, payload) {
    let url = URI.TARGET_DEPLOYMENT_HEADER_DELETE.replace(
      "{headerId}",
      payload
    );
    const response = await BaseService.getSchemePlanningClient().delete(url, {
      data: payload,
    });
    return response.data;
  },
  async targetDeploymentHeaderUpdateAction({ commit }, payload) {
    const url = URI.TARGET_DEPLOYMENT_HEADER_UPDATE.replace(
      "{headerId}",
      payload.headerId
    ).replace("{status}", payload.status);
    const response = await BaseService.getSchemePlanningClient().put(
      url,
      payload
    );
    return response.data;
  },

  // Lines
  async targetDeploymentLineItemDynamicHeaderAction({ commit }, payload) {
    const url = URI.TARGET_DEPLOYMENT_LINE_DYNAMIC_HEADER.replace(
      "{deploymentId}",
      payload.id
    );
    const res = await BaseService.getSchemePlanningClient().get(url);
    commit("setTargetDeploymentLineDynamicHeader", res.data);
    return res.data;
  },
  async targetDeploymentLineItemDynamicListAction({ commit }, payload) {
    const url = URI.TARGET_DEPLOYMENT_LINE_DYNAMIC_LIST.replace(
      "{deploymentId}",
      payload.id
    );
    const res = await BaseService.getSchemePlanningClient().get(url);
    commit("setTargetDeploymentLineDynamicList", res.data);
    return res.data;
  },
  async targetDeploymentLineItemExportAction({ commit }, payload) {
    let url = URI.TARGET_DEPLOYMENT_LINE_EXPORT.replace(
      "{deploymentId}",
      payload.id
    );
    const response = await BaseService.getSchemePlanningClient().get(url, {
      responseType: "blob",
    });
    return response;
  },
  async targetDeploymentLineItemImportCSVAction({ commit }, payload) {
    let url = URI.TARGET_DEPLOYMENT_LINE_IMPORT.replace(
      "{deploymentId}",
      payload.deploymentId
    );
    const response = await BaseService.getSchemePlanningClient().post(
      url,
      payload.data,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );
    return response.data;
  },
  async targetDeploymentLineItemDeleteAction({ commit }, payload) {
    let ids = payload.item.map((obj) => `journalLines=${obj}`).join("&");
    let url = URI.TARGET_DEPLOYMENT_LINE_DELETE.replace(
      "{payload}",
      ids
    ).replace("{journalCode}", payload.journalCode);
    const response = await BaseService.getSchemePlanningClient().delete(url, {
      data: payload,
    });
    return response.data;
  },
};

export default action;
